// QCM PCG — Cabinet KEYTO. 20 questions à choix multiples.
// Chaque question : un énoncé, 4 options, l'index de la bonne réponse, une explication.

export const QCM = [
  {
    id: 1,
    theme: "Logique des classes",
    q: "Dans le PCG, à quelle classe appartient le compte 411 « Clients » ?",
    options: ["Classe 3 (stocks)", "Classe 4 (tiers)", "Classe 5 (financiers)", "Classe 7 (produits)"],
    correct: 1,
    explication:
      "La classe 4 regroupe tous les comptes de tiers : clients (41), fournisseurs (40), État (44), personnel (42). Le 411 « Clients » est bien en classe 4.",
  },
  {
    id: 2,
    theme: "Mécanique",
    q: "Quelle affirmation décrit correctement le DÉBIT d'un compte ?",
    options: [
      "Une diminution d'actif",
      "Une augmentation d'actif, une diminution de passif ou une charge",
      "Une augmentation de passif",
      "Un produit constaté",
    ],
    correct: 1,
    explication:
      "Au débit : augmentation d'actif, diminution de passif, ou constatation d'une charge. C'est l'inverse pour le crédit.",
  },
  {
    id: 3,
    theme: "Vente avec TVA",
    q: "Une vente de marchandises 1 000 € HT avec TVA 20 %, à crédit. Quel compte est débité ?",
    options: ["707 pour 1 000 €", "411 pour 1 200 €", "707 pour 1 200 €", "44571 pour 200 €"],
    correct: 1,
    explication:
      "Le client doit le TTC : on débite 411 pour 1 200 €. En contrepartie : 707 au crédit pour 1 000 € (HT) et 44571 au crédit pour 200 € (TVA collectée).",
  },
  {
    id: 4,
    theme: "Achat de marchandises",
    q: "Quel compte de TVA déductible utilise-t-on pour un achat de marchandises courant ?",
    options: ["44551", "44562", "44566", "44571"],
    correct: 2,
    explication:
      "44566 = TVA déductible sur Achats de Biens et Services (ABS). 44562 est réservé aux immobilisations, 44571 est la TVA collectée, 44551 est la TVA à décaisser.",
  },
  {
    id: 5,
    theme: "Immobilisations",
    q: "Quel compte enregistre la dotation aux amortissements d'une immobilisation corporelle ?",
    options: ["28154", "6811", "68112", "657"],
    correct: 2,
    explication:
      "68112 = Dotations aux amortissements des immobilisations corporelles (charge). Le 28154 est sa contrepartie (amortissement cumulé du matériel industriel, au passif d'actif).",
  },
  {
    id: 6,
    theme: "Sens des comptes",
    q: "Quel est le sens normal d'un compte de la classe 7 (produits) ?",
    options: ["Débiteur", "Créditeur", "Nul", "Mixte"],
    correct: 1,
    explication:
      "Les produits (classe 7) sont créditeurs : on crédite quand on enregistre une vente ou un produit. À l'inverse, les charges (classe 6) sont débitrices.",
  },
  {
    id: 7,
    theme: "Glossaire",
    q: "Que désigne le BFR (Besoin en Fonds de Roulement) ?",
    options: [
      "Le capital social de l'entreprise",
      "Stocks + Créances − Dettes d'exploitation",
      "Le résultat net de l'exercice",
      "La trésorerie disponible",
    ],
    correct: 1,
    explication:
      "BFR = Stocks + Créances clients − Dettes fournisseurs et sociales. C'est le capital « gelé » par le cycle d'exploitation.",
  },
  {
    id: 8,
    theme: "Clôture",
    q: "Au 31/12, une charge est consommée en N mais la facture arrive en N+1. Quel compte utilise-t-on ?",
    options: ["486 (CCA)", "487 (PCA)", "408 (FNP)", "418 (FAE)"],
    correct: 2,
    explication:
      "Facture Non Parvenue (FNP) → compte 408. Permet de rattacher la charge à l'exercice N. 408 est crédité en miroir du 60x débité.",
  },
  {
    id: 9,
    theme: "TVA",
    q: "TVA collectée du mois : 1 800 €. TVA déductible : 1 200 €. Que devient le solde ?",
    options: [
      "Crédit de TVA de 600 €",
      "TVA à décaisser de 600 €",
      "Charge de TVA de 3 000 €",
      "Aucun impact",
    ],
    correct: 1,
    explication:
      "TVA collectée > TVA déductible → solde dû à l'État. 1 800 − 1 200 = 600 € à reverser via le compte 44551 « TVA à décaisser ».",
  },
  {
    id: 10,
    theme: "Bilan",
    q: "Quelle équation fondamentale doit toujours être vérifiée au bilan ?",
    options: [
      "Charges = Produits",
      "Actif = Passif + Résultat",
      "Débits = Crédits du mois",
      "Stocks = Ventes",
    ],
    correct: 1,
    explication:
      "Au bilan, Actif = Passif (incluant le résultat de l'exercice). C'est la traduction de la partie double : tout euro qui entre quelque part vient d'ailleurs.",
  },
  {
    id: 11,
    theme: "Différences classiques",
    q: "Quelle est la différence entre 706 et 707 ?",
    options: [
      "Aucune, ce sont des synonymes",
      "706 = ventes de marchandises, 707 = prestations de services",
      "706 = prestations de services, 707 = ventes de marchandises",
      "706 = ventes export, 707 = ventes France",
    ],
    correct: 2,
    explication:
      "706 = Prestations de services (immatériel). 707 = Ventes de marchandises (biens revendus en l'état). Mémo : 706 pour le service, 707 pour le bien.",
  },
  {
    id: 12,
    theme: "Paie",
    q: "Salaire brut 2 000 €, cotisations salariales 22 %. Quel est le net à payer ?",
    options: ["1 560 €", "1 600 €", "2 000 €", "2 440 €"],
    correct: 0,
    explication:
      "Net = Brut − Cotisations salariales = 2 000 − (2 000 × 22 %) = 2 000 − 440 = 1 560 €. Les cotisations patronales sont en plus, à la charge de l'employeur.",
  },
  {
    id: 13,
    theme: "Cession d'immobilisation",
    q: "Lors d'une cession d'immo, quel compte enregistre la Valeur Nette Comptable en charge ?",
    options: ["757", "757 et 657", "657", "2154"],
    correct: 2,
    explication:
      "657 = Valeurs comptables des éléments d'actif cédés (VCEAC). En face, 757 enregistre le produit de cession. Plus-value = 757 − 657.",
  },
  {
    id: 14,
    theme: "Dépréciation",
    q: "Sur quelle base calcule-t-on la dépréciation d'une créance client douteuse ?",
    options: ["Montant TTC", "Montant HT", "TVA uniquement", "Aucun calcul"],
    correct: 1,
    explication:
      "Toujours sur le HT. La TVA reste récupérable tant que la créance n'est pas définitivement perdue, on ne déprécie que la partie qui représenterait une vraie perte.",
  },
  {
    id: 15,
    theme: "Trésorerie",
    q: "Quel compte enregistre les virements bancaires entre deux comptes de l'entreprise ?",
    options: ["512", "53", "58", "509"],
    correct: 2,
    explication:
      "58 = Virements internes. Utilisé en transition pour les transferts banque → caisse ou compte courant → livret. Soldé en fin de période.",
  },
  {
    id: 16,
    theme: "Capitaux",
    q: "Le compte 12 « Résultat de l'exercice » est :",
    options: [
      "Toujours créditeur (bénéfice)",
      "Toujours débiteur (perte)",
      "Créditeur si bénéfice, débiteur si perte",
      "Soldé à zéro chaque mois",
    ],
    correct: 2,
    explication:
      "12 = Résultat de l'exercice. Créditeur en cas de bénéfice (Produits > Charges), débiteur en cas de perte. Au passif du bilan dans tous les cas.",
  },
  {
    id: 17,
    theme: "Fournisseurs",
    q: "Quelle différence entre les comptes 401 et 404 ?",
    options: [
      "Aucune",
      "401 = fournisseurs courants, 404 = fournisseurs d'immobilisations",
      "401 = fournisseurs étrangers, 404 = fournisseurs France",
      "401 = à crédit, 404 = au comptant",
    ],
    correct: 1,
    explication:
      "401 pour les achats courants (marchandises, services). 404 réservé aux fournisseurs d'immobilisations. Permet d'isoler les dettes liées à l'investissement.",
  },
  {
    id: 18,
    theme: "Régularisations",
    q: "Quel compte sert à reporter à l'exercice suivant un loyer payé d'avance ?",
    options: ["486 (CCA)", "487 (PCA)", "408 (FNP)", "418 (FAE)"],
    correct: 0,
    explication:
      "486 = Charges Constatées d'Avance. On y stocke la part du loyer qui appartient à l'exercice N+1. Contre-passé en début N+1.",
  },
  {
    id: 19,
    theme: "Lettrage",
    q: "À quoi sert le lettrage en comptabilité ?",
    options: [
      "À mettre des étiquettes sur les comptes",
      "À mettre en correspondance les écritures débit/crédit d'un même compte de tiers",
      "À classer les comptes par ordre alphabétique",
      "À supprimer les écritures soldées",
    ],
    correct: 1,
    explication:
      "Le lettrage associe une facture à son règlement (sur 411 ou 401) pour identifier les soldes vivants. Indispensable pour la relance client.",
  },
  {
    id: 20,
    theme: "Synthèse",
    q: "Une écriture comptable est-elle valide si Σ Débits ≠ Σ Crédits ?",
    options: [
      "Oui, c'est fréquent",
      "Oui si la différence est < 1 €",
      "Non jamais — la partie double exige l'équilibre exact",
      "Seulement pour les écritures d'inventaire",
    ],
    correct: 2,
    explication:
      "Non. La partie double impose : Σ Débits = Σ Crédits, au centime près. Sans cette égalité, le bilan ne tient pas debout. C'est LA règle d'or.",
  },
];

// Pioche N questions au hasard (sans remise)
export function pickRandom(n) {
  const a = [...QCM];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a.slice(0, Math.min(n, a.length));
}
